// NDA General Ability Test (GAT) Questions
// Extracted from Jay Defence Academy Dharwad Question Papers

export const ndaGATSet1 = [
  {
    id: 1,
    question: "Who was the son of Chandragupta Maurya?",
    options: ["Bindusara", "Chandragupta II", "Ashoka", "Bimbisara"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 2,
    question: "The Translation of which text is known as Razmnamah?",
    options: ["Ramayana", "Lilavati", "Atharvaveda", "Mahabharata"],
    correctAnswer: 3,
    category: "History"
  },
  {
    id: 3,
    question: "The Vijaynagar ruler Krishna Dev Raya's work 'Amuktamalayada' was written in which language?",
    options: ["Marathi", "Malayalam", "Kanada", "Telugu"],
    correctAnswer: 3,
    category: "History"
  },
  {
    id: 4,
    question: "Who was the first French governor of Pondicherry?",
    options: ["Franco Martin", "Francis Day", "Charles Eyre", "Job Charnock"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 5,
    question: "Hussain Sagar Lake is located in?",
    options: ["Bangalore", "Hyderabad", "Bhubaneswar", "Murshidabad"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 6,
    question: "Which wind is cold?",
    options: ["Mistral", "Sirocco", "Chinook", "Loo"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 7,
    question: "Canterbury grasslands are found in which country?",
    options: ["New Zealand", "Argentina", "U.S.A.", "South Africa"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 8,
    question: "Amazon River flows through which country?",
    options: ["USA", "Chile", "Brazil", "Argentina"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 9,
    question: "The planet closest to the Sun is:",
    options: ["Earth", "Mars", "Mercury", "Venus"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 10,
    question: "Which planet is called 'Blue Planet'?",
    options: ["Sun", "Earth", "Moon", "Venus"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 11,
    question: "Tehri Dam is situated at which river?",
    options: ["Ganga, Uttar Pradesh", "Bhagirathi, Uttarakhand", "Krishna, Maharashtra", "Jhelum, Jammu and Kashmir"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 12,
    question: "Sardar Sarovar Dam is situated on which river?",
    options: ["Chambal, Rajasthan", "Shipra, Maharashtra", "Gomti, Uttar Pradesh", "Narmada, Gujarat"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 13,
    question: "What is the international date line?",
    options: ["180° longitude line", "0° longitude line", "0° to 180° east longitude", "0° to 180° west longitude"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 14,
    question: "When was the Panchayati Raj System introduced in India?",
    options: ["1950 A.D.", "1945 A.D.", "1949 A.D.", "1959 A.D."],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 15,
    question: "The first law commission was established in 1834 under the chairmanship of:",
    options: ["Lord Macaulay", "Lord Dalhousie", "Lord Canning", "Lord North Brook"],
    correctAnswer: 0,
    category: "Polity"
  },
  {
    id: 16,
    question: "Who makes laws on matters in Union List and Concurrent List?",
    options: ["Parliament", "Ministry of Defense", "Prime Minister's Office", "SEBI"],
    correctAnswer: 0,
    category: "Polity"
  },
  {
    id: 17,
    question: "What is the full form of RTGS in banking?",
    options: ["Real Time Gap Settlement", "Real Time Gross Settlement", "Real Term Gap Settlement", "Real Time Gross Sell out"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 18,
    question: "What is the full form of NEFT in banking sector?",
    options: ["National Electronic Fund Transparent System", "National Electronics Funds Transfer System", "National Electronic Fund Transfer System", "National Electrical Fund Transparent System"],
    correctAnswer: 2,
    category: "Economics"
  },
  {
    id: 19,
    question: "The working principle of a washing machine is:",
    options: ["Reverse osmosis", "Diffusion", "Centrifugation", "Dialysis"],
    correctAnswer: 2,
    category: "Physics"
  },
  {
    id: 20,
    question: "Who invented the first working laser?",
    options: ["Alhazen", "Carl Anderson", "T. H. Maiman", "Charles Barkla"],
    correctAnswer: 2,
    category: "Physics"
  }
];

export const ndaGATSet2 = [
  {
    id: 1,
    question: "The phonograph was invented by which scientist?",
    options: ["Hans Geiger", "Hans Oersted", "Thomas Edison", "Paul Cornu"],
    correctAnswer: 2,
    category: "Physics"
  },
  {
    id: 2,
    question: "The process of depositing a layer of metal on another material by electricity is called:",
    options: ["Electroplating", "Galvanisation", "Rusting", "Crystallisation"],
    correctAnswer: 0,
    category: "Physics"
  },
  {
    id: 3,
    question: "Who invented the waterproof raincoat?",
    options: ["Robert Hooke", "Cai Lun", "Charles Macintosh", "William Harvey"],
    correctAnswer: 2,
    category: "General Science"
  },
  {
    id: 4,
    question: "Red light is used for signals because it has:",
    options: ["Long wavelength", "High Intensity", "High Frequency", "Low refraction"],
    correctAnswer: 0,
    category: "Physics"
  },
  {
    id: 5,
    question: "The sky appears blue because of:",
    options: ["Atmospheric water vapour", "Scattering of light", "Reflection on sea water", "Emission of blue wavelength by the Sun"],
    correctAnswer: 1,
    category: "Physics"
  },
  {
    id: 6,
    question: "Optical Fiber works on the principle of:",
    options: ["Dispersion of light", "Diffraction of light", "Total internal reflection", "Interference of light"],
    correctAnswer: 2,
    category: "Physics"
  },
  {
    id: 7,
    question: "The Bhopal Gas Tragedy of 1984 was due to the leakage of:",
    options: ["Methyl isocyanate", "Nitrous oxide", "Methane", "Carbon monoxide"],
    correctAnswer: 0,
    category: "General Science"
  },
  {
    id: 8,
    question: "The chemical substance used to relieve pain is called:",
    options: ["Antihistamine", "Antiseptic", "Tranquilizer", "Analgesic"],
    correctAnswer: 3,
    category: "Chemistry"
  },
  {
    id: 9,
    question: "What are isobars?",
    options: ["Elements with same atomic number but different mass number", "Elements with different atomic number but same mass number", "Elements with different atomic number and mass number", "All of the above"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 10,
    question: "Which metal does not undergo corrosion due to oxide layer formation?",
    options: ["Zinc", "Aluminum", "Iron", "Copper"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 11,
    question: "Which fuel causes minimum environmental pollution?",
    options: ["Diesel", "Coal", "Gasoline", "Hydrogen"],
    correctAnswer: 3,
    category: "Chemistry"
  },
  {
    id: 12,
    question: "The edible part of turmeric is:",
    options: ["Root", "Rhizome", "Fruit", "Corm"],
    correctAnswer: 1,
    category: "Biology"
  },
  {
    id: 13,
    question: "Plants are green due to which pigment?",
    options: ["Carotenoid", "Lycopene", "Anthocyanin", "Chlorophyll"],
    correctAnswer: 3,
    category: "Biology"
  },
  {
    id: 14,
    question: "'The Queen of Herbs' with scientific name Ocimum Sanctum is commonly called:",
    options: ["Tulsi", "Rosemary", "Thyme", "Coriander"],
    correctAnswer: 0,
    category: "Biology"
  },
  {
    id: 15,
    question: "Which crop is known for producing biodiesel?",
    options: ["Jatropha", "Candlenut tree", "Copper leaf", "Sarpagandha"],
    correctAnswer: 0,
    category: "Biology"
  },
  {
    id: 16,
    question: "Energy flow in an ecosystem follows which series?",
    options: ["Producers→Decomposers→Consumers", "Decomposers→Consumers→Producers", "Producers→Consumers→Decomposers", "Consumers→Producers→Decomposers"],
    correctAnswer: 2,
    category: "Biology"
  },
  {
    id: 17,
    question: "Which Tuber is an underground stem?",
    options: ["Onion", "Ginger", "Potato", "Crocus"],
    correctAnswer: 2,
    category: "Biology"
  },
  {
    id: 18,
    question: "Hemoglobin is an important component of:",
    options: ["White blood cells", "Red blood cells", "Plasma", "Platelets"],
    correctAnswer: 1,
    category: "Biology"
  },
  {
    id: 19,
    question: "Anemia is caused due to deficiency of:",
    options: ["Calcium", "Iron", "Vitamin C", "Protein"],
    correctAnswer: 1,
    category: "Biology"
  },
  {
    id: 20,
    question: "The founder of Slave dynasty was:",
    options: ["Iltutamish", "Qutubuddin Aibak", "Bakhtiyar Khilji", "Balban"],
    correctAnswer: 1,
    category: "History"
  }
];

export const ndaGATSet3 = [
  {
    id: 1,
    question: "Who was the first female emperor of India?",
    options: ["Razia Sultana", "Noor Jahan", "Maham Anga", "Rukkiya Begum"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 2,
    question: "Who received both Bharat Ratna and Nishan-e-Pakistan?",
    options: ["Jawaharlal Nehru", "Morarji Desai", "Maulana Abdul Kalam Azad", "Ayub Khan"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 3,
    question: "The ruins of Vijayanagara at Hampi were brought to light in 1800 by:",
    options: ["Colonel Colin Mackenzie", "Sir John Shore", "Andrew Fraser", "John Marshall"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 4,
    question: "India's first national news agency was:",
    options: ["The Indian Review", "The Free Press of India", "The Hindustan Review", "The Associated Press of India"],
    correctAnswer: 3,
    category: "History"
  },
  {
    id: 5,
    question: "Kattaikkuttu is the famous folk drama of which state?",
    options: ["Andhra Pradesh", "Bihar", "Rajasthan", "Tamil Nadu"],
    correctAnswer: 3,
    category: "Culture"
  },
  {
    id: 6,
    question: "Jallikattu practiced in Tamil Nadu is a part of which festival?",
    options: ["Onam", "Pongal", "Natyanjali", "Hampi"],
    correctAnswer: 1,
    category: "Culture"
  },
  {
    id: 7,
    question: "In which city is the Forest Research Institute of India located?",
    options: ["New Delhi", "Kolkata", "Dehradun", "Shimla"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 8,
    question: "Which is the highest peak in Andaman and Nicobar islands?",
    options: ["Mount Koya", "Mount Diavolo", "Saddle Peak", "Mount Thuiller"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 9,
    question: "Which neighbouring country of India is not landlocked?",
    options: ["Nepal", "Myanmar", "Bhutan", "Afghanistan"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 10,
    question: "What is the capital of Manipur?",
    options: ["Agartala", "Imphal", "Shillong", "Aizawl"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 11,
    question: "Which Indian state has the largest share of Wastelands?",
    options: ["Rajasthan", "Bihar", "Karnataka", "Uttar Pradesh"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 12,
    question: "Name the state where Brahmaputra River enters India first:",
    options: ["Sikkim", "Arunachal Pradesh", "Assam", "Manipur"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 13,
    question: "Lokayukta was first introduced in which state?",
    options: ["Uttar Pradesh", "Punjab", "Maharashtra", "Tamil Nadu"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 14,
    question: "What is the literal meaning of 'Certiorari'?",
    options: ["We command", "To have the body of", "To forbid", "To be certified/informed"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 15,
    question: "Right to Equality includes abolition of untouchability under which Article?",
    options: ["Article 14", "Article 15", "Article 17", "Article 19"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 16,
    question: "Who is not a member of either House of Parliament?",
    options: ["Prime Minister", "Finance Minister", "President", "Defense Minister"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 17,
    question: "Who selects the Social Audit Committee under MGNREGA scheme?",
    options: ["Chief Minister", "Gram Sabha", "Mayor", "B.D.O."],
    correctAnswer: 1,
    category: "Polity"
  },
  {
    id: 18,
    question: "Goods for which demand increases as income increases are called:",
    options: ["Inferior Goods", "Normal Goods", "Complementary Goods", "Substitute Goods"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 19,
    question: "In which year was EXIM Bank of India set up?",
    options: ["1980", "1981", "1982", "1989"],
    correctAnswer: 2,
    category: "Economics"
  },
  {
    id: 20,
    question: "Which deposit type gives the highest rate of interest?",
    options: ["Current account", "Fixed account", "Recurring account", "None of these"],
    correctAnswer: 2,
    category: "Economics"
  }
];

export const ndaGATSet4 = [
  {
    id: 1,
    question: "Where is the tomb of Bahadur Shah Zafar (II), the last Mughal emperor?",
    options: ["Rangoon (Yangon), Myanmar", "Delhi, India", "Aurangabad, India", "Kabul, Afghanistan"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 2,
    question: "Who founded the Indian Independence League?",
    options: ["Lala Lajpat Rai", "Aurobindo Ghosh", "Rasbehari Bose", "Subhash Chandra Bose"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 3,
    question: "Which event was probed by the Hunter Commission?",
    options: ["Chauri Chaura incident", "Demolition of Kanpur mosque", "Jallianwala Bagh massacre", "Kakori train dacoity"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 4,
    question: "The Ghadr (Ghadar) was a:",
    options: ["Revolutionary association with HQ at San Francisco", "Nationalist organization from Japan", "Militant organization with HQ at London", "Communist movement with HQ at Delhi"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 5,
    question: "Ramayana was translated into Persian at Akbar's court by:",
    options: ["Faizi", "Abul Fazl", "Badayuni", "Haji Ibrahim Sirhindi"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 6,
    question: "Which grasslands are found in Africa?",
    options: ["Pampas", "Veld", "Savanna", "Llanos"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 7,
    question: "The world's most shallow ocean is:",
    options: ["Arctic Ocean", "Indian Ocean", "Pacific Ocean", "Atlantic Ocean"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 8,
    question: "The oldest oil field in India is:",
    options: ["Bombay High, Maharashtra", "Ankleshwar, Gujarat", "Navagam, Gujarat", "Digboi, Assam"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 9,
    question: "Which of these is NOT a conservative force?",
    options: ["Electrostatic force", "Magnetic force", "Force in elastic spring", "Frictional force"],
    correctAnswer: 3,
    category: "Physics"
  },
  {
    id: 10,
    question: "Light Emitting Diode (LED) converts:",
    options: ["Light energy into electrical energy", "Electrical energy into light energy", "Thermal energy into light energy", "Mechanical energy into electrical energy"],
    correctAnswer: 1,
    category: "Physics"
  },
  {
    id: 11,
    question: "Who invented the Centigrade scale?",
    options: ["Anders Celsius", "Daniel Gabriel Fahrenheit", "William Thomson", "Thomas Edison"],
    correctAnswer: 0,
    category: "Physics"
  },
  {
    id: 12,
    question: "Bats can fly in the dark because they:",
    options: ["Can see in darkness", "Have weak legs", "Generate flashes of light", "Generate ultrasonic sound waves"],
    correctAnswer: 3,
    category: "Physics"
  },
  {
    id: 13,
    question: "Recoil of a gun is an example of:",
    options: ["Conservation of mass", "Conservation of energy", "Conversion to Kinetic Energy", "Conservation of linear momentum"],
    correctAnswer: 3,
    category: "Physics"
  },
  {
    id: 14,
    question: "Aviation fuel for jet aeroplanes consists of purified:",
    options: ["Petrol", "Kerosene", "Gasoline", "Diesel"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 15,
    question: "What is the chemical formula for Sodium Chloride (Salt)?",
    options: ["NaCl2", "NaCl", "Na2Cl", "Na2C"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 16,
    question: "Which method of water purification does not kill microorganisms?",
    options: ["Boiling", "Filtration", "Chlorination", "UV-irradiation"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 17,
    question: "Which is used to treat Indigestion?",
    options: ["Antacid", "Antiseptic", "Analgesic", "Antibiotic"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 18,
    question: "If a refrigerator's door is kept open, then:",
    options: ["Room will be cooled", "Room will be heated", "Depends on weather", "No effect on room"],
    correctAnswer: 1,
    category: "Physics"
  },
  {
    id: 19,
    question: "Quorum for Rajya Sabha meeting is:",
    options: ["One-tenth of Lok Sabha members", "One-tenth of total members of the house", "50 members", "30 members"],
    correctAnswer: 1,
    category: "Polity"
  },
  {
    id: 20,
    question: "Which is NOT an instrument of credit control in India?",
    options: ["Rationing of credit", "Direct Action", "Open Market operations", "Variable cost reserve ratios"],
    correctAnswer: 3,
    category: "Economics"
  }
];

// NEW SETS FROM ADDITIONAL PDFs

export const ndaGATSet5 = [
  {
    id: 1,
    question: "Which of the following was the only organization of Indian labors in 1938?",
    options: ["Indian National Trade Union Congress", "All India Red Trade Union Congress", "All India Trade Union Congress", "All of the above"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 2,
    question: "Operation Rubicon was the code word proposed by British Government in India with reference to:",
    options: ["Gandhi's fast unto death in Jail", "Activities of Jai Prakash Narayan", "Gandhi's participation in Round Table Conference", "None of the above"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 3,
    question: "\"Bagh-e Babur\" where Babur is buried is located at?",
    options: ["Tashkent", "Karachi", "Lahore", "Kabul"],
    correctAnswer: 3,
    category: "History"
  },
  {
    id: 4,
    question: "Tropic of Cancer does not pass through which region:",
    options: ["Indore", "Ujjain", "Jabalpur", "Bhopal"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 5,
    question: "Which mountain range separates France from Spain?",
    options: ["Rocky Mountain", "Andes Mountain", "Pyrenees Mountain", "Alps Mountains"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 6,
    question: "Which of the following has maximum bio-diversity?",
    options: ["Desert", "River", "Polar Region", "Tropical Region"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 7,
    question: "Netaji Subhash Chandra Bose International Airport is located at?",
    options: ["New Delhi", "Kolkata", "Chennai", "Mumbai"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 8,
    question: "Under the constitution of India who are the ultimate Sovereign?",
    options: ["Indian People", "Prime Minister of India", "President of India", "All elected leaders of India"],
    correctAnswer: 0,
    category: "Polity"
  },
  {
    id: 9,
    question: "\"Prevention of cruelty to animals\" is listed in which list in the Seventh Schedule?",
    options: ["Union", "State", "Global", "Concurrent"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 10,
    question: "Which one of the following is NOT an element of the State?",
    options: ["Population", "Land", "Army", "Government"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 11,
    question: "Which grant is raised when amount authorized by Appropriation Act is found insufficient?",
    options: ["Exceptional Grant", "Supplementary Grant", "Vote of credit", "Vote on account"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 12,
    question: "The Club of Rome is related to?",
    options: ["Economic Development", "Economic growth", "Sustainable Development", "Developed economy"],
    correctAnswer: 2,
    category: "Economics"
  },
  {
    id: 13,
    question: "Which of the following country is not the member of G-20 group?",
    options: ["India", "Russia", "Australia", "Uruguay"],
    correctAnswer: 3,
    category: "Economics"
  },
  {
    id: 14,
    question: "Transfer of heat energy from the sun to the moon takes place by:",
    options: ["Radiation only", "Radiation and conduction", "Radiation and convection", "Radiation, conduction, and convection"],
    correctAnswer: 0,
    category: "Physics"
  },
  {
    id: 15,
    question: "The action of a nib split at the top of the pen is explained by:",
    options: ["Gravity flow", "Diffusion of fluid", "Capillary action", "Osmosis of liquid"],
    correctAnswer: 2,
    category: "Physics"
  },
  {
    id: 16,
    question: "Which element forms the highest number of compounds in the periodic table?",
    options: ["Carbon", "Oxygen", "Silicon", "Sulphur"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 17,
    question: "Which metals are present in hemoglobin and chlorophyll, respectively?",
    options: ["Fe and Mg", "Fe and Zn", "Mg and Zn", "Zn and Mg"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 18,
    question: "Which one of the following is involved in the desalination of sea water?",
    options: ["Reverse Osmosis", "Simple Osmosis", "Use of Sodium Aluminum silicate", "Use of ion selective electrodes"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 19,
    question: "Which among the following has a segmented body?",
    options: ["Phylum Platyhelminthes", "Phylum Annelida", "Phylum Porifera", "Phylum Coelenterata"],
    correctAnswer: 1,
    category: "Biology"
  },
  {
    id: 20,
    question: "Which organ has finger like outgrowths called Villi?",
    options: ["Large Intestine", "Pancreas", "Small Intestine", "Stomach"],
    correctAnswer: 2,
    category: "Biology"
  }
];

export const ndaGATSet6 = [
  {
    id: 1,
    question: "Todarmal was the famous revenue minister of which Mughal Emperor?",
    options: ["Shah Jahan", "Babur", "Akbar", "Aurangzeb"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 2,
    question: "Who gave the slogan 'Back to the Vedas (Vedo ki aur lauto)'?",
    options: ["Bal Gangadhar Tilak", "Dayanand Saraswati", "Swami Vivekananda", "Raja Ram Mohan Roy"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 3,
    question: "Which Act gives power to the Indian Legislative Council to debate on the budget?",
    options: ["Indian Council Act 1861", "Indian Council Act 1862", "Indian Council Act 1892", "Indian Council Act 1909"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 4,
    question: "Who among the Sultans of the Slave dynasty reigned for the longest period?",
    options: ["Balban", "Firoz Tughlaq", "Iltutmish", "Alauddin Khilji"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 5,
    question: "Who built the Ibadatkhana at Fatehpur Sikri?",
    options: ["Akbar", "Jahangir", "Shah Jahan", "Aurangzeb"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 6,
    question: "Which state of India has the highest Human Development Index?",
    options: ["Tamil Nadu", "Kerala", "Punjab", "Haryana"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 7,
    question: "Which continent is spread in both the northern and southern hemispheres?",
    options: ["Asia", "South America", "Africa", "North America"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 8,
    question: "The monsoon responsible for rains in Jharkhand is:",
    options: ["North-east monsoon", "South-west monsoon", "Northwester", "None of the above"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 9,
    question: "Omkareshwar Dam is situated on which river?",
    options: ["Narmada", "Betwa", "Chambal", "Tungabhadra"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 10,
    question: "Which Act led to the introduction of dual system of government in India?",
    options: ["Pitt's India Act, 1784", "The Regulating Act, 1773", "Charter Act, 1793", "Charter Act, 1813"],
    correctAnswer: 0,
    category: "Polity"
  },
  {
    id: 11,
    question: "The Judge of the High Courts in India is administered oath of office by:",
    options: ["The Chief Justice of the High Court", "The Governor of the State", "The President of India", "The Chief Justice of India"],
    correctAnswer: 1,
    category: "Polity"
  },
  {
    id: 12,
    question: "Which one among the following is not a constitutional body in India?",
    options: ["Comptroller and Auditor General of India", "National Commissioner for Minorities", "National Commission for Scheduled Castes", "National Human Rights Commission"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 13,
    question: "Which Country does have a written Constitution?",
    options: ["Israel", "UK", "The U.S.A.", "Saudi Arabia"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 14,
    question: "Which among the following comes under primary sector of Indian Economy?",
    options: ["Sugar Industry", "Dairy", "Banking", "Transport of Goods"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 15,
    question: "What is the critical angle in the water-air boundary?",
    options: ["51.21°", "67.19°", "50.26°", "56.11°"],
    correctAnswer: 0,
    category: "Physics"
  },
  {
    id: 16,
    question: "Lead articles when exposed to atmosphere turn black due to reaction with:",
    options: ["Carbon dioxide", "Hydrogen sulphide", "Oxygen", "Sulphur dioxide"],
    correctAnswer: 1,
    category: "Chemistry"
  },
  {
    id: 17,
    question: "Which of the following is a Sanguinivorous (blood-feeding) organism?",
    options: ["Deer", "Rabbit", "Mosquito", "Lizard"],
    correctAnswer: 2,
    category: "Biology"
  },
  {
    id: 18,
    question: "The total amount of blood present in a normal human adult (70 kg) is about:",
    options: ["5-6 liters", "2-3 liters", "3-4 liters", "1-2 liters"],
    correctAnswer: 0,
    category: "Biology"
  },
  {
    id: 19,
    question: "Which enzyme converts proteins into amino acids?",
    options: ["Proteases", "Lactase", "Urease", "Zymase"],
    correctAnswer: 0,
    category: "Biology"
  },
  {
    id: 20,
    question: "Which of the following is a female sex-hormone?",
    options: ["Androsterone", "Testosterone", "Oestrogen", "Thyroxine"],
    correctAnswer: 2,
    category: "Biology"
  }
];

export const ndaGATSet7 = [
  {
    id: 1,
    question: "Whose reign was called the Golden age of Mughal Era?",
    options: ["Akbar", "Jahangir", "Shah Jahan", "Humayun"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 2,
    question: "Who wrote Panchatantra?",
    options: ["Sudraka", "Vishnu Gupta", "Vishnu Sharma", "Bharata Muni"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 3,
    question: "Which Mughal ruler installed a 'Bell of Justice'?",
    options: ["Akbar", "Jahangir", "Aurangzeb", "Humayun"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 4,
    question: "Which movement is related to the Teenkathiya system?",
    options: ["Quit India Movement", "Kheda Satyagraha", "Champaran Satyagraha", "Non-cooperation Movement"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 5,
    question: "Who was the Governor-General when Indian National Congress was founded in 1885?",
    options: ["Lord Linlithgow", "Lord Wellesley", "Lord Dufferin", "Lord Salisbury"],
    correctAnswer: 2,
    category: "History"
  },
  {
    id: 6,
    question: "Which gas in our atmosphere absorbs the harmful UV rays of the Sun?",
    options: ["Methane", "Ozone", "Helium", "Neon"],
    correctAnswer: 1,
    category: "Geography"
  },
  {
    id: 7,
    question: "What is the latitude of the Tropic of Cancer?",
    options: ["0° latitude", "23½° South latitude", "23½° Northern latitude", "66½° Northern latitude"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 8,
    question: "Baghdad is the capital of which country?",
    options: ["Thailand", "Mongolia", "Iraq", "Somalia"],
    correctAnswer: 2,
    category: "Geography"
  },
  {
    id: 9,
    question: "Taklamakan Desert is situated in:",
    options: ["Western Asia", "Southern fringe of Sahara in Africa", "North America", "Central Asia"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 10,
    question: "Which article states no discrimination on grounds of caste, religion, race, sex, place of birth?",
    options: ["Article 15", "Article 21", "Article 25", "Article 30"],
    correctAnswer: 0,
    category: "Polity"
  },
  {
    id: 11,
    question: "Which fundamental right is given in Article 21?",
    options: ["Right to property", "Right to equality", "Right to speech", "Right to life"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 12,
    question: "Which tax is collected by Panchayat?",
    options: ["Sales Tax", "Custom Duty", "Land Revenue", "Tax on Local fairs"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 13,
    question: "Which is not an instrument of fiscal policy?",
    options: ["Taxation", "Public expenditure", "Public debt", "Credit Rationing"],
    correctAnswer: 3,
    category: "Economics"
  },
  {
    id: 14,
    question: "Fiscal Policy in India is formulated by:",
    options: ["The Reserve Bank of India", "The Planning Commission", "The Finance Ministry", "SEBI"],
    correctAnswer: 2,
    category: "Economics"
  },
  {
    id: 15,
    question: "Which is the first bank established in India?",
    options: ["Bank of Maharashtra", "Bank of Hindustan", "State Bank of India", "Punjab National Bank"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 16,
    question: "What is a transformer?",
    options: ["Converts DC into AC", "Used to reduce and increase AC voltage", "Converts AC voltage to DC voltage", "Converts electrical energy into mechanical energy"],
    correctAnswer: 1,
    category: "Physics"
  },
  {
    id: 17,
    question: "The Laser is a beam of radiations which are:",
    options: ["Non-coherent and non-monochromatic", "Coherent and non-monochromatic", "Non-coherent and monochromatic", "Coherent and monochromatic"],
    correctAnswer: 3,
    category: "Physics"
  },
  {
    id: 18,
    question: "Which acid is used in car battery?",
    options: ["Nitric acid", "Hydrochloric acid", "Carbonic acid", "Sulphuric acid"],
    correctAnswer: 3,
    category: "Chemistry"
  },
  {
    id: 19,
    question: "Which is present in chlorophyll which gives green colour to plant leaves?",
    options: ["Calcium", "Magnesium", "Iron", "Manganese"],
    correctAnswer: 1,
    category: "Biology"
  },
  {
    id: 20,
    question: "Which animal breathes through the skin?",
    options: ["Fish", "Pigeon", "Frog", "Cockroach"],
    correctAnswer: 2,
    category: "Biology"
  }
];

export const ndaGATSet8 = [
  {
    id: 1,
    question: "Which rulers of Bengal had relations with China?",
    options: ["Ghiyasuddin Azamshah", "Sikandar Shah", "Nusrat Shah", "Hussein Shah"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 2,
    question: "The earliest reference to sati custom is made in which inscription?",
    options: ["Allahabad Pillar inscription", "Eran inscription of Bhanugupta", "Aihole inscription of Pulkesin II", "Bhitan inscription of Skandgupta"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 3,
    question: "Who was the 24th Tirthankar of Jainism?",
    options: ["Rishabh Dev", "Mahavir Swami", "Parshvanath", "Aristhenemi"],
    correctAnswer: 1,
    category: "History"
  },
  {
    id: 4,
    question: "The Gandhara art flourished largely during which dynasty?",
    options: ["Kushan", "Gupta", "Pallava", "Maurya"],
    correctAnswer: 0,
    category: "History"
  },
  {
    id: 5,
    question: "Which is the most optimum place to source Geothermal Energy in India?",
    options: ["Himalaya", "Konkan coast", "Coromandal Coast", "Ladakh district"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 6,
    question: "The K2 Peak is located in which range?",
    options: ["Karakoram range", "Trans-Himalayas", "Central Himalayas", "Kumaun Himalayas"],
    correctAnswer: 0,
    category: "Geography"
  },
  {
    id: 7,
    question: "Which are the two volcanic Islands in the Indian Territory?",
    options: ["Kavaratti and New Moore", "Bitra and Kavaratti", "Pamban and Barren", "Narcondam and Barren"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 8,
    question: "Which country is known as 'The Land of the Morning Calm'?",
    options: ["Japan", "Malaysia", "Indonesia", "South Korea"],
    correctAnswer: 3,
    category: "Geography"
  },
  {
    id: 9,
    question: "Which part of the constitution is related to the President post?",
    options: ["Part-4", "Part-5", "Part-6", "Part-7"],
    correctAnswer: 1,
    category: "Polity"
  },
  {
    id: 10,
    question: "In which article is the process of amendment of the constitution mentioned?",
    options: ["Article-352", "Article-356", "Article-368", "Article-355"],
    correctAnswer: 2,
    category: "Polity"
  },
  {
    id: 11,
    question: "Ministers of the government are collectively responsible to:",
    options: ["The President", "The Prime Minister", "Supreme Court", "The Parliament"],
    correctAnswer: 3,
    category: "Polity"
  },
  {
    id: 12,
    question: "Who propounded the Innovation theory of profits?",
    options: ["J.A. Schumpeter", "P.A. Samuelson", "Alfred Marshall", "David Ricardo"],
    correctAnswer: 0,
    category: "Economics"
  },
  {
    id: 13,
    question: "Under perfect competition, each firm produces at the minimum point on its:",
    options: ["Long-run marginal cost curve", "Long-run average cost curve", "Long-run average variable cost curve", "Long-run average revenue curve"],
    correctAnswer: 1,
    category: "Economics"
  },
  {
    id: 14,
    question: "Open market operations of a Central Bank are sale and purchase of:",
    options: ["Foreign Currencies", "Corporate Securities", "Trade bills", "Government Securities"],
    correctAnswer: 3,
    category: "Economics"
  },
  {
    id: 15,
    question: "The Nucleus of an atom consists of:",
    options: ["Protons and neutrons", "Protons and electrons", "Electrons", "Protons"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 16,
    question: "In the dry cell, which is used as electrolyte?",
    options: ["Ammonium chloride and zinc chloride", "Sodium chloride and calcium chloride", "Magnesium chloride and zinc chloride", "Ammonium chloride and calcium chloride"],
    correctAnswer: 0,
    category: "Chemistry"
  },
  {
    id: 17,
    question: "A mixture with non-uniformly mixed constituents is called:",
    options: ["Element", "Metalloids", "Homogeneous", "Heterogeneous"],
    correctAnswer: 3,
    category: "Chemistry"
  },
  {
    id: 18,
    question: "The two gases used in industrial production of sulfuric acid are:",
    options: ["Carbon dioxide and oxygen", "Sulfur dioxide and hydrogen", "Sulfur dioxide and oxygen", "Sulfur dioxide and chlorine"],
    correctAnswer: 2,
    category: "Chemistry"
  },
  {
    id: 19,
    question: "Synapse gap is present between which of the following?",
    options: ["Two neurons", "Brain and Spinal Cord", "Two Kidneys", "Chamber of heart"],
    correctAnswer: 0,
    category: "Biology"
  },
  {
    id: 20,
    question: "Who discovered malaria causing germs?",
    options: ["Christian Bernard", "Charles Louis Alphonse Laveran", "Dmitry Ivanovsky", "Carl Landsteiner"],
    correctAnswer: 1,
    category: "Biology"
  }
];

// Combined question bank for random selection
export const allNdaGATQuestions = [
  ...ndaGATSet1, 
  ...ndaGATSet2, 
  ...ndaGATSet3, 
  ...ndaGATSet4,
  ...ndaGATSet5,
  ...ndaGATSet6,
  ...ndaGATSet7,
  ...ndaGATSet8
];

// Function to get random GAT questions
export const getRandomGATQuestions = (count = 10) => {
  const shuffled = [...allNdaGATQuestions].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map((q, index) => ({
    ...q,
    id: index + 1
  }));
};

// GAT Categories
export const gatCategories = [
  "All",
  "History",
  "Geography",
  "Polity",
  "Economics",
  "Physics",
  "Chemistry",
  "Biology",
  "General Science",
  "Culture"
];
